import React from 'react';

interface Props {
  sellerName?: string;
  buyerName?: string;
  propertyCondition?: string;
  // Use seller property info if available, otherwise fall back to agent property info
  propertyAddress?: string;
  propertyCounty?: string;
  propertyCity?: string;
  propertyState?: string;
  propertyZipCode?: string;
  legalDescription?: string;
}

const PropertyInfo: React.FC<Props> = ({
  legalDescription,
  propertyCondition,
  propertyCounty,
  propertyAddress,
  propertyCity,
  propertyState,
  propertyZipCode,
}) => (
  <>
    <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
      PROPERTY INFORMATION
    </h2>
    <ol className=" list-decimal ml-4">
      <li>
        By this agreement Seller agrees to sell and Buyer agrees to buy the real
        property located at:{' '}
        <span className="font-semibold">{propertyAddress}</span>
      </li>
      <li>
        The Property is located in:{' '}
        <span className="font-semibold">
          {propertyCity || propertyCounty
            ? `${propertyCity || propertyCounty}, `
            : ''}
          {propertyState} {propertyZipCode}
        </span>
      </li>

      <li>
        The Property is legally described as follows:{' '}
        <span className="font-semibold">{legalDescription}</span>
      </li>

      <li>
        The Property is being purchased in{' '}
        <span className="font-semibold">{propertyCondition}</span> condition.
      </li>
    </ol>
  </>
);

export default PropertyInfo;
